export function FlagIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M2 14V11.3333M2 11.3333V3.33333C2 2.59695 2.59695 2 3.33333 2H7.66667L8.33333 2.66667H14L12 6.66667L14 10.6667H8.33333L7.66667 10H3.33333C2.59695 10 2 10.597 2 11.3333ZM8 2.33333V6'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
